import { cva } from "class-variance-authority";

export const CARD_VARIANTS = ["default", "floating"] as const;

export type CardVariant = (typeof CARD_VARIANTS)[number];

export const CARD_PADDINGS = ["parts", "root"] as const;

export type CardPadding = (typeof CARD_PADDINGS)[number];

export const cardVariants = cva("flex flex-col bg-card text-card-foreground", {
  variants: {
    variant: {
      default: "w-full min-w-0 overflow-hidden rounded-md border",
      floating: "rounded-2xl shadow-lg",
    } satisfies Record<CardVariant, string>,
    padding: {
      parts: "",
      root: "gap-6",
    } satisfies Record<CardPadding, string>,
    divided: {
      true: "divide-y",
      false: "",
    },
  },
  compoundVariants: [
    { variant: "floating", padding: "parts", className: "py-3" },
    { variant: "default", padding: "root", className: "py-3" },
    { variant: "floating", padding: "root", className: "py-6" },
  ],
  defaultVariants: { variant: "default", padding: "parts", divided: false },
});

export const cardRegionVariants = cva("", {
  variants: {
    variant: {
      default: "px-4",
      floating: "px-6",
    } satisfies Record<CardVariant, string>,
    padding: {
      parts: "py-3",
      root: "",
    } satisfies Record<CardPadding, string>,
  },
  defaultVariants: { variant: "default", padding: "parts" },
});

export const cardHeaderVariants = cva("flex flex-col gap-1.5");

export const cardBodyVariants = cva("has-[>[data-slot=card-section]]:p-0", {
  variants: {
    variant: {
      default: "text-sm",
      floating: "",
    } satisfies Record<CardVariant, string>,
    padding: {
      parts: "",
      root: "has-[>[data-slot=card-section]]:flex has-[>[data-slot=card-section]]:flex-col has-[>[data-slot=card-section]]:gap-6",
    } satisfies Record<CardPadding, string>,
    divided: {
      true: "divide-y",
      false: "",
    },
  },
  defaultVariants: { variant: "default", padding: "parts", divided: false },
});

export const cardFooterVariants = cva("flex flex-wrap items-center justify-between gap-2", {
  variants: {
    variant: {
      default: "px-4",
      floating: "px-6",
    } satisfies Record<CardVariant, string>,
    padding: {
      parts: "",
      root: "",
    } satisfies Record<CardPadding, string>,
  },
  compoundVariants: [
    { variant: "default", padding: "parts", className: "py-2" },
    { variant: "floating", padding: "parts", className: "py-3" },
  ],
  defaultVariants: { variant: "default", padding: "parts" },
});

export const cardTitleVariants = cva("font-semibold leading-none");

export const cardDescriptionVariants = cva("text-sm text-muted-foreground");
